import { _,moment,Radio } from '../../../vendor'
import { Backform,Biscuit,Notification } from '../../utils'
import OffCanvasFacilitiesFormTpl from '../../templates/facilities/OffCanvasFacilitiesFormTpl.html'
import InboomaBaseView from '../InboomaBaseView'

import OffCanvasBehavior from '../../behaviors/Behavior.OffCanvas'

import FacilitySlots from '../../collections/FacilitySlots'

import FacilitySlot from '../../models/FacilitySlot'
import Facility from '../../models/Facility'


export default InboomaBaseView.extend({
  template : OffCanvasFacilitiesFormTpl,
  el : '#inb-off-canvas',
  parentView: 'facilities',
  _autoGenerateAmount: 0,

  behaviors: [
    {
      behaviorClass: OffCanvasBehavior,
      beforeSave : (model, view) => {
          
        if (model.get('id') === null) {

          if (model.get('do_bulk_action')) {
            view._autoGenerateAmount = model.get('number_slots');
          }

          delete model.attributes.do_bulk_action;
          
          model.set('client_id', Number(Biscuit.get('user.client_id')));
            
          model.set('error_code', '');
          model.set('error_text', '');
        }
        
        //FIX: API duplicates facility_slots amount if facility_slots array is submitted in PUT as is
        model.set('facility_slots', [], {silent: true});
        view._facility_slotsTempStore = model.get('facility_slots');
        delete model.attributes.facility_slots;

      },
      afterSaveSuccess : (model, view, response) => {

        const isNew = view.isNew;

        model = new Facility(model.toJSON());

        //FIX: API duplicates facility_slots amount if facility_slots array is submitted in PUT as is
        model.set('facility_slots', new FacilitySlots(view._facility_slotsTempStore), {silent: true});
        
        view._resourcesTempStore = [];

        // eventually append resources[] to post-model
        if (view._autoGenerateAmount >= 1) {
          // Auto-generate facility slots

          for (var i = 0; i < view._autoGenerateAmount; i++) {

            let res = new FacilitySlot(
              {
                "facility_id": Number(model.get('id')),
                "status": "active"
              }
            );
            
            delete res.attributes.created;
            delete res.attributes.modified;
            delete res.attributes.deleted;

            res.save(null,{
              type: 'POST',
              success (_model, response, options) {

                model.attributes.facility_slots.push(_model);
                model.trigger('changed');

              }, error (_model, response, options) {
                console.log('error adding facility slot', _model, response); 
              }
            });
          }
        }

        view.collection.set(model, { add:true, merge:true, remove:false });

        new Notification({
          message : view.t((isNew ? 'saved_${a}' : 'updated_${a}'),{a:view.t('facility')},'capital'),
          duration : 5000,
          type : 'success',
          closeable : true,
          icon : 'fi fi-check'
        });

      }, afterSaveError : (model, view) => {

        new Notification({
          message : view.t('request_error'),
          duration : 5000,
          type : 'warning',
          closeable : true,
          icon : 'fi fi-check'
        });

      }
    },
  ],

  initialize () {
    this.render()
  },

  templateContext () {
    return {
      'created_printable' : moment(this.model.get('created')),
      'modified_printable' : moment(this.model.get('modified')),
    }
  },

  onRender () {

    this.isNew = (this.model.get('id') == '');

    const that = this,
          locations = Radio.channel('locations').request('get:data');

    let fields = [
      {
        name: "location_id",
        control: "selector",
        label: this.t('location',null,'capital'),
        hasMultiple: () => (that.model.get('resourcetype_id') == 3),
        placeholder: this.t('select_${a}',{a:this.t('location')}),
        forceFirstSelected: true,
        required: true,
        options : _.map(locations.models, (location, __) => {
          return { label : location.get('name'), value : location.get('id')  }
        }),
        size : {
          "large" : "6",
          "small" : "12"
        },
      },
      {
        name: "status",
        control: "select",
        label: this.t('status',null,'capital'),
        hasMultiple: () => (that.model.get('resourcetype_id') == 3),
        placeholder: this.t('select_${a}',{a:this.t('status')}),
        options : [ 
            { label : this.t('active',null,'capital'), value : 'active'  },
            { label : this.t('inactive',null,'capital'), value : 'inactive'  }, 
        ],
        required : true,
        size : {
          "large" : "6",
          "small" : "12"
        },
      },
    ];

    if (this.isNew) {

      this.model.set('do_bulk_action', true);

      fields.push(
      {
        name: "number_slots",
        label: this.t('number_slots',null,'capital'),
        control: "input",
        required : true,
        size : {
          "large" : "6",
          "small" : "12"
        },
      },
      {
        control: "spacer",
        extraTopClasses: ['depend-non-appointment']
      },    
     {
        name: "do_bulk_action",
        //forceActive : true,
        label: this.t('autogenerate_facility_slots'),
        helpMessage : this.t('autogenerate_facilities_body'),
        control: "boolean",
        size : {
          "large" : "12"
        },
        extraTopClasses: ['depend-non-appointment']
      });

    }

    this.form = new Backform.Form({

      el: that.$el.find('#facilities-form'),
      collection: that.collection,
      model: that.model,
      fields

    }).render();

  }

});